document.addEventListener('DOMContentLoaded', () => {
  const blocks = document.querySelectorAll('.credo-about')
  if (!blocks.length) return

  // ── Galéria top pozíció beállítása heading alapján ───────────────────
  blocks.forEach((block) => {
    const heading = block.querySelector('.credo-about__heading')
    const imgWrap = block.querySelector('.credo-about__img-wrap')
    if (!heading || !imgWrap) return

    const headingBottom = heading.getBoundingClientRect().bottom
    const blockTop = block.getBoundingClientRect().top
    const topOffset = headingBottom - blockTop - 150

    imgWrap.style.top = `${topOffset}px`
  })

  // --- ÚJ: Observer a fejléc és szöveg animációjához ---
  const contentObserver = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible')
          obs.unobserve(entry.target) // Animáció csak egyszer fusson le
        }
      })
    },
    {
      threshold: 0.1, // Az elem 10%-a látható
    },
  )

  // --- MEGLÉVŐ: Observer a csapattagok animációjához ---
  const teamObserver = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        // akkor triggereljen, ha a target legalább 15%-a látszik
        if (!entry.isIntersecting || entry.intersectionRatio < 0.15) return

        const block = entry.target.closest('.credo-about')
        if (!block) return

        block.classList.add('is-team-visible')
        obs.unobserve(entry.target)
      })
    },
    {
      threshold: [0, 0.15, 0.3],
      rootMargin: '0px 0px -5% 0px',
    },
  )

  // --- Ciklus a blokkokon ---
  blocks.forEach((block) => {
    // ÚJ: A contentObserver figyelje a blokkot a fejléc/szöveg animációhoz
    contentObserver.observe(block)

    // MEGLÉVŐ: Logika a csapattagokhoz
    const members = block.querySelectorAll('.credo-about__member')
    if (!members.length) return

    block.classList.add('has-team-reveal')

    members.forEach((member, i) => {
      member.style.setProperty('--reveal-delay', `${i * 90}ms`)
    })

    const trigger = block.querySelector('.credo-about__team') || block
    teamObserver.observe(trigger)
  })

  // ── About galéria scroll parallax ────────────────────────────────────
  document.querySelectorAll('.credo-about').forEach((block) => {
    const tracks = block.querySelectorAll('.credo-about__img-track')
    if (!tracks.length) return

    // Alap CSS animáció offset tárolása
    const baseOffsets = Array.from(tracks).map((track, i) => {
      // páros sor: jobbra indul (-50%), páratlan: balra (0%)
      return i % 2 === 0 ? 0 : -50
    })

    let scrollY = window.scrollY
    let lastScrollY = scrollY
    let ticking = false
    let parallax = [0, 0, 0] // px offset soronként

    const STRENGTH = 0.08 // mennyire erős a parallax

    function update() {
      const delta = scrollY - lastScrollY
      lastScrollY = scrollY

      tracks.forEach((track, i) => {
        // 1. és 3. sor: scrolliránnyal megegyező, 2. sor: ellentétes
        const direction = i % 2 === 0 ? 1 : -1
        parallax[i] = (parallax[i] || 0) + delta * STRENGTH * direction

        // CSS animáció + parallax offset kombinálva
        track.style.transform = `translateX(${parallax[i]}px)`
      })

      ticking = false
    }

    window.addEventListener(
      'scroll',
      () => {
        scrollY = window.scrollY
        if (!ticking) {
          requestAnimationFrame(update)
          ticking = true
        }
      },
      { passive: true },
    )
  })
})
